import React, { useEffect, useState } from 'react';
import { useSettingActions } from 'src/store/settings/actions';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store/reducers/state';
import AddCertificateTemplate from './AddCertificateTemplate';
import Pagination from 'src/components/common/pagination';
import { useNavigate } from 'react-router-dom';
const CertificateTemplate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const settingAction = useSettingActions(dispatch);
  const [editflag, setEditFlag] = useState(false);
  const { certificateTemplates, isCertificateTemplateAdded, paginationMeta } = useSelector(
    (state: RootState) => {
      return {
        certificateTemplates: state.setting.certificateTemplates,
        isCertificateTemplateAdded: state.setting.isCertificateTemplateAdded,
        paginationMeta: state.setting.paginationMeta
      };
    }
  );

  useEffect(() => {
    settingAction.getCertificateTemplatesRequest({ pageNumber: 1 });
  }, []);

  useEffect(() => {
    if (isCertificateTemplateAdded) {
      settingAction.getCertificateTemplatesRequest({ pageNumber: 1 });
    }
  }, [isCertificateTemplateAdded]);

  const handleEditClick = (id: string) => {
    settingAction.getSingleCertificateTemplatesRequest(id);
    navigate(`/certificate-editor/${id}`);
  };

  const handleDeleteClick = (id: string) => {
    settingAction.deleteCertificateTemplateRequest(id);
  };

  const handlePageChange = (pageNumber: any) => {
    settingAction.getCertificateTemplatesRequest({ pageNumber });
  };
  return (
    <>
      <div className="tab-pane fade" id="tabs-certificate" role="tabpanel">
        <div className="md:p-5 p-3">
          <div className="py-5 px-7">
            <div className="text-right">
              <div className="dropdown relative">
                <button
                  onClick={() => setEditFlag(false)}
                  className="btn-primary w-auto mt-0 mr-0 ml-auto mb-4"
                  type="button"
                  id="action-dropdown"
                  data-bs-toggle="modal"
                  data-bs-target="#AddCertificateTemplate">
                  Add New
                </button>
              </div>
            </div>{' '}
            <div>
              <table className="table-auto w-full border">
                <thead className="text-xs font-semibold uppercase bg-gray-100">
                  <tr>
                    <th className="p-2">
                      <div className="font-semibold text-left">Template Name</div>
                    </th>
                    <th className="p-2">
                      <div className="text-left invisible">Action</div>
                    </th>
                  </tr>
                </thead>
                <tbody className="text-sm divide-y divide-gray-100">
                  {certificateTemplates &&
                    certificateTemplates.map((item) => {
                      return (
                        <tr key={item.certificateId}>
                          <td className="p-2">{item.certificateTemplateName}</td>
                          <td className="p-2">
                            <div className="dropdown relative">
                              <a
                                className="
                        dropdown-toggle
                        transition
                        duration-150
                        ease-in-out border h-8 w-8 flex items-center justify-center rounded-md"
                                href="#"
                                type="button"
                                id="ActionButton"
                                data-bs-toggle="dropdown"
                                aria-expanded="false">
                                <i className="fas fa-ellipsis-v"></i>
                              </a>
                              <ul
                                className="dropdown-menu action-dropdown"
                                aria-labelledby="ActionButton">
                                <li onClick={() => handleEditClick(item.certificateId)}>
                                  <span className="dropdown-item flex-items cursor-pointer">
                                    <i className="fas fa-edit w-6"></i>
                                    <span>Edit</span>
                                  </span>
                                </li>
                                <li onClick={() => handleDeleteClick(item.certificateId)}>
                                  <span className="dropdown-item flex-items cursor-pointer text-red-500">
                                    <i className="fas fa-trash w-6"></i>
                                    <span>Delete</span>
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
              {!!paginationMeta && !!Object.keys(paginationMeta).length && (
                <Pagination
                  currentPage={paginationMeta.pageNumber}
                  totalCount={paginationMeta.totalCount}
                  pageSize={paginationMeta.pageSize}
                  onPageChange={(page: any) => handlePageChange(page)}
                />
              )}
            </div>
          </div>
        </div>
        <AddCertificateTemplate editflag={editflag} />
      </div>
    </>
  );
};

export default CertificateTemplate;
